import { HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on an outgoing request, `tokenInterceptor` will NOT call
 * `dialog.closeAll()` if that request receives a connectivity-failure response
 * (HTTP status 0 or 503).
 *
 * Use this for requests that are legitimately expected to be aborted — for
 * example, a logout POST that is in-flight while Angular is tearing down the
 * current router state.  Without the flag those aborts (status 0) would
 * incorrectly trigger a global dialog-close even though the user is still
 * authenticated and no real outage has occurred.
 *
 * @example
 * this.http.post('/api/login/logout', {}, {
 *   context: new HttpContext().set(SKIP_CONNECTIVITY_DIALOG_CLOSE, true)
 * });
 */
export const SKIP_CONNECTIVITY_DIALOG_CLOSE = new HttpContextToken<boolean>(() => false);

